import React from "react";
import FormGetQuote from "./FormGetQuote";

/**
 * 渲染 PCB 即时报价页面，并限制报价专属样式的作用范围。
 * @returns {JSX.Element} 报价页面
 */
export default function GetQuoteScreen() {
  return (
    <div className="creatyea-padding get-a-quote-section pcb-quote-page">
      <FormGetQuote />
    </div>
  );
}
